import { jwtDecode } from 'jwt-decode';
import { clearUser } from './userSlice';

export const checkTokenAndLogout = () => (dispatch) => {
    const token = localStorage.getItem('accessToken');
    const currentPath = window.location.pathname;

    // Only check tokens if not on the login page
    if (currentPath === '/login') return;

    if (!token) return;

    try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000; // ms → seconds

        if (decoded.exp && decoded.exp < currentTime) {
            console.warn('Token expired, logging out...');
            dispatch(clearUser());
            localStorage.removeItem('accessToken'); // prevent loops
            window.location.href = '/login';
        }
    } catch (error) {
        console.error('Invalid token, logging out...', error);
        dispatch(clearUser());
        localStorage.removeItem('accessToken');
        window.location.href = '/login';
    }
};
